// extracted by mini-css-extract-plugin
export default {"container":"hea_3lbhh","reserved":"hea_res_txjhz"};